export interface UserCentricsEventDetail {
  [MATOMO_ID]: boolean;
}

export interface UserCentrics {
  matomo: boolean;
}

export const MATOMO_ID = 'Matomo (self hosted)';
